export default "__VITE_ASSET__CS7Tk_ej__"